import Vue, {
  Ref,
  unref
} from 'vue';

import {
  AvailableCardRanges
} from './types';

import {
  checkCard
} from "@/components/cards/scripts/cardApiRequests";

/**
 * checks value is typeof string and not longer than 255 chars
 *
 * returns true if value is string and not longer than 255 chars otherwise false
 *
 * if value is not a string returns true
 *
 * @param {string} value
 */
const isStringAndHasLength = (value: string | any) => typeof value === 'string' && value.length <= 255 || true;

/**
 * checks given startNumber and endNumber is in an array of given ranges
 *
 * @param  {Ref<AvailableCardRanges[]>}ranges
 * @param {Ref<number>} startNumber
 * @param {Ref<number>} endNumber
 */
const isStartAndEndInRanges = (ranges: Ref<AvailableCardRanges[]>, startNumber: Ref<number>, endNumber: Ref<number>) => {
  const arrayOfRanges = unref(ranges);
  const start = unref(startNumber);
  const end = unref(endNumber);

  if (!arrayOfRanges) return true;

  return arrayOfRanges.some((range) => range.from <= start
    && range.from <= end
    && range.to >= start
    && range.to >= end
  );
}

/**
 * checks a given number is in array of given ranges
 *
 * @param  {Ref<AvailableCardRanges[]>}ranges
 * @param {Ref<number>} value
 */
const isNumberInRanges = (ranges: Ref<AvailableCardRanges[]>, value: Ref<number>) => {
  const arrayOfRanges = unref(ranges);
  const comparator = unref(value);

  if (!arrayOfRanges) return true;

  return arrayOfRanges.some((range) => comparator >= range.from && comparator <= range.to);
};

/**
 * checks a given number is equal or higher than a given comparator number
 *
 * @param {Ref<number>} start
 * @param {Ref<number>} end
 */
const isEndEqualOrHigherThanStart = (start: Ref<number>, end: Ref<number>) => unref(end) >= unref(start);

/**
 * checks if a given cardNumber exists within the city card context
 *
 * @param cardNumber
 */
const cardExist = async (cardNumber: number | undefined) : Promise<boolean> => {
  if(!cardNumber) return false;

  let minCardNumber = Number.parseInt(Vue.prototype.$config.CardNumberRange.MinimumCardNumber);
  let maxCardNumber = Number.parseInt(Vue.prototype.$config.CardNumberRange.MaximumCardNumber);

  if(Number.isNaN(minCardNumber) || Number.isNaN(maxCardNumber)){
    minCardNumber = 10000000;
    maxCardNumber = 99999999;
  }

  if(cardNumber < minCardNumber || cardNumber > maxCardNumber) return false;

  const { response, error } = await checkCard(cardNumber);
  if(error) return false;

  return response ?  response[0].isActive : false;
}

export {
  isEndEqualOrHigherThanStart,
  isNumberInRanges,
  isStartAndEndInRanges,
  isStringAndHasLength,
  cardExist
}
